import React, { useRef, useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Column from "./Column";
import Icon from "./Icon";
import Row from "./Row";
import { TextTitle } from "./Texts";
import colors from "../styles/colors";
import styled from "styled-components";
import useWindowSize from "../layout/useWindowSize";
import { useHistory } from "react-router-dom";
import withUserPerm from "services/withUserPerm";
import { compose } from "redux";
import mainAction from "../modules/main/actions";
import mainSelectors from "../modules/main/selectors";
import { ThreeDotsVertical } from "styled-icons/bootstrap";
import packageJson from "package.json";
import businessSelectors from "modules/business/selectors";
import businessActions from "modules/business/actions";
import decodeHTMLEntities from "modules/utils/DecodeHTMLEntities";

const Header = ({ onSettingClick }) => {
  const [t] = useTranslation();
  const windowSize = useWindowSize();
  const history = useHistory();
  const goToSetting = () => {
    if (onSettingClick) {
      onSettingClick();
    }
    history.push("/setting");
    sessionStorage.setItem("email", null);
  };
  const { REACT_APP_RMP_WIDGET, REACT_APP_RMP_HELP_CONTACT } = process.env;
  const isWizard = history.location.pathname === "/wizard";
  console.log("isWizard", isWizard);
  const dispatch = useDispatch();
  const currentDashboard = useSelector((state) => mainSelectors.currentDashboardResult(state));
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const businessAccount = useSelector((state) => businessSelectors.getBusinessAccountResult(state));
  const [isOptionsVisible, setOptionsVisible] = useState(false);
  const rmpToken = sessionStorage.getItem("rmp_token");

  useEffect(() => {
    if (document.getElementById("rmp_widget_js")) {
      return;
    } else {
      const script = document.createElement("script");
      script.id = "rmp_widget_js";
      script.src = REACT_APP_RMP_WIDGET;
      document.body.appendChild(script);
    }
  }, [REACT_APP_RMP_WIDGET]);

  useEffect(() => {
    dispatch(
      businessActions.getBusinessAccount({
        token: rmpToken,
      }),
    );
  }, [rmpToken]);

  const TextWithTooltip = ({ elementType: ElementType, content }) => {
    const textRef = useRef(null);
    const [isBusinessNameOverflowing, setIsBusinessNameOverflowing] = useState(false);

    const mouseHoverHeader = () => {
      const textElement = textRef.current;
      const isBusinessNameOverflowing = textElement.scrollWidth > textElement.clientWidth;
      setIsBusinessNameOverflowing(isBusinessNameOverflowing);
    };

    return (
      <>
        <ElementType data-tip={isBusinessNameOverflowing ? content : null} ref={textRef} onMouseOver={mouseHoverHeader}>
          {content}
        </ElementType>
        {isBusinessNameOverflowing && (
          <ReactTooltip className="tooltip-style" place="bottom" type="dark" effect="solid" />
        )}
      </>
    );
  };

  const changeDashboard = (history, dispatch, dashboard) => {
    dispatch(mainAction.currentDashboard(dashboard));

    if (dashboard === "google") {
      if (
        authAdproResult.data.adwords_managed_service === "N" ||
        authAdproResult.data.adwords_managed_service === "U"
      ) {
        history.push("/dashboard/self-service");
      } else {
        history.push("/dashboard");
      }
    } else if (dashboard === "facebook") {
      history.push("/dashboard/fb");
    } else if (dashboard === "settings") {
      goToSetting();
    }
  };

  const handleShowMore = () => {
    setOptionsVisible(!isOptionsVisible);
  };

  const onDropdownItemSelected = () => {
    setOptionsVisible(false);
  };

  const DropdownItem = ({ item, index, onClick }) => {
    return (
      <>
        {item.type === "item" && (
          <StyledItem onClick={() => onClick(item, index)}>
            <CallLink href={`tel:${REACT_APP_RMP_HELP_CONTACT}`}>
              <div className="icon-circle bg-blue">
                <StylePhone src="/images/call.svg" />
              </div>
              <div className="menu-info">
                <h4>{item.title}</h4>
              </div>
            </CallLink>
          </StyledItem>
        )}
        {item.type === "version" && (
          <VersionItem>
            <div className="version-text">Version: {item.title}</div>
          </VersionItem>
        )}
      </>
    );
  };

  let items = [
    { type: "item", title: t("__open_contact") },
    { type: "version", title: `${packageJson.version}` },
  ];
  const viewItems = () =>
    items.map((item, index) => (
      <DropdownItem key={index} item={item} index={index} onClick={() => onDropdownItemSelected()}></DropdownItem>
    ));

  if (windowSize.width > 834)
    return (
      <Container>
        <Row className="wrapper" alignItems="center">
          <Column>
            <TextWithTooltip
              elementType={HeaderTitle}
              content={
                businessAccount.result === 0 && businessAccount.msg === "GET_DATA_COMPLETED"
                  ? decodeHTMLEntities(businessAccount.data.business_name)
                  : businessAccount.result === 1
                  ? "R-Ads"
                  : null
              }
            />
          </Column>
          <AdsMenuColumn align="right">
            <AdsMenuContainer
              onClick={() => changeDashboard(history, dispatch, "google")}
              className={
                currentDashboard.data.dashboard === "google" && history.location.pathname !== "/setting"
                  ? "selected"
                  : ""
              }
            >
              Google
            </AdsMenuContainer>
            <AdsMenuContainer
              onClick={() => changeDashboard(history, dispatch, "facebook")}
              className={
                currentDashboard.data.dashboard === "facebook" &&
                history.location.pathname !== "/setting" &&
                history.location.pathname !== "/setting/fb"
                  ? "selected"
                  : ""
              }
            >
              Meta
            </AdsMenuContainer>
            {!isWizard ? (
              <AdsMenuContainer
                onClick={() => changeDashboard(history, dispatch, "settings")}
                className={
                  currentDashboard.data.dashboard === "settings" &&
                  (history.location.pathname === "/setting" || history.location.pathname === "/setting/fb")
                    ? "selected"
                    : ""
                }
              >
                {t("__settings_menu")}
              </AdsMenuContainer>
            ) : null}
          </AdsMenuColumn>
          <Column align="right" wrap>
            <Icon
              name="icon-help-circled"
              size="18px"
              color={colors.white}
              onClick={() => window.open("https://help.readyplanet.com/17612069/r-adpro", "_blank")}
            ></Icon>
            <RMPSwitcher></RMPSwitcher>
            <MoreContainer>
              <StyleThreeDotsVertical size="16" onClick={handleShowMore} />
              <ItemsContainer isVisible={isOptionsVisible} position={{ top: "30px", right: "0" }} minWidth={"270px"}>
                {viewItems()}
              </ItemsContainer>
              {isOptionsVisible && <Backdrop onClick={() => setOptionsVisible(false)} />}
            </MoreContainer>
          </Column>
        </Row>
      </Container>
    );
  else
    return (
      <MobileContainer alignItems="center">
        <Column>
          <TextTitle color={colors.white}>
            {businessAccount.result === 0 && businessAccount.msg === "GET_DATA_COMPLETED"
              ? businessAccount.data.business_name
              : businessAccount.result === 1
              ? "R-Ads"
              : null}
          </TextTitle>
        </Column>
        <Column className="menus" align="right" wrap>
          <Icon
            name="icon-help-circled"
            size="20px"
            color={colors.white}
            onClick={() => window.open("https://help.readyplanet.com/17612069/r-adpro", "_blank")}
          ></Icon>
          <RMPSwitcher></RMPSwitcher>
        </Column>
      </MobileContainer>
    );
};

export default compose(withUserPerm())(Header);

const RMPSwitcher = ({ mobile }) => {
  return <div className="rmp-widget" id="rmp_widget" data-source-app-id="1"></div>;
};

/*const SwitcherContainer = styled(Row)`
  background-color: #fff
  align-items: center;
  padding: 2px 2px 2px 8px;
  display: inline-flex;
  border-radius: 4px;
  min-width: 110px;
  text-align: left;
`*/

const Container = styled.div`
  background-color: ${colors.primary};
  margin: 0 0 8px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 997;

  .tooltip-style {
    border-radius: 4px;
    opacity: 1 !important;
    max-width: 600px;
    line-height: 1.5rem;
  }

  .wrapper > .column > i {
    margin-right: 16px;
  }
`;

const HeaderTitle = styled.p`
  margin: 0;
  font-size: 20px;
  color: #fff;
  font-family: "Poppins", "Kanit", "Helvetica Neue", sans-serif;
  word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}
`;

const MobileContainer = styled(Row)`
  padding: 16px;
  background-color: ${colors.primary};
  margin: 0 !important;
  position: sticky;
  top: 0;

  .menus {
    display: flex;
    align-items: center;

    & > * {
      margin-left: 16px;
      height: 30px;
    }
  }
`;

const AdsMenuColumn = styled(Column)`
  display: flex;
`;

const AdsMenuContainer = styled.div`
  padding: 16px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;

  &.selected {
    border-bottom: 2px solid #ffffff;
    font-weight: bold;
  }
`;

const MoreContainer = styled.div`
  position: relative;
  display: inline-block;

  > *:first-child {
    cursor: pointer;
  }
`;

const ItemsContainer = styled.div.attrs((props) => ({
  display: props.isVisible ? "block" : "none",
  top: props.position ? props.position.top : "35px",
  right: props.position && props.position.right ? props.position.right : null,
  minWidth: props.minWidth,
}))`
  display: ${(props) => props.display};
  position: absolute;
  background-color: ${colors.backgroundSection};
  box-shadow: ${colors.sectionShadow} 0 10px 30px;
  z-index: 999;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  min-width: ${(props) => props.minWidth};
  text-align: left;
  overflow: auto;
  margin: 2px 0;
  left: auto;
  border-radius: 10px;

  @media screen and (max-width: 834px) {
    box-shadow: none;
    width: calc(100% - 32px);
    position: fixed;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: 16px;
    text-align: center;
    max-height: calc(100vh - 150px);
    min-width: unset;

    p {
      font-size: 14px;
    }
  }
`;

const StyledItem = styled.div`
  cursor: pointer;

  @media screen and (max-width: 834px) {
    padding: 16px;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;

  @media screen and (max-width: 834px) {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

const StyleThreeDotsVertical = styled(ThreeDotsVertical)`
  color: ${colors.white};
  cursor: pointer;
  width: 18px;
  height: 18px;
  margin-left: 16px;
  position: relative;
  top: -2px;
`;

const StylePhone = styled.img`
  cursor: pointer;
  width: 16px;
  height: 16px;
  line-height: 36px;
  position: relative;
  top: -16px;
`;

const CallLink = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  text-decoration: none;
  overflow: hidden;
  padding: 7px 11px;
  transition: 0.5s;
  .menu-info {
    display: inline-block;
    position: relative;
    left: 10px;
  }

  h4 {
    margin: 0;
    font-size: 13px;
    color: #333;
  }

  .icon-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #2196f3 !important;
    text-align: center;
    display: inline-block;
  }

  .bg-blue {
    background-color: #2196f3 !important;
  }

  &:hover {
    color: #23527c;
    background-color: #e9e9e9;
  }
`;

const VersionItem = styled.div`
  border-top: 1px solid #ddd;
  padding: 5px;
  font-size: 10px;
  .version-text {
    height: 20px;
    line-height: 20px;
    font-size: 10px;
    text-align: right;
    color: #8f8f8f;
  }
`;
